import script from "./ChartValues.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartValues.vue?vue&type=script&lang=ts&setup=true"

import "./ChartValues.vue?vue&type=style&index=0&id=032a2074&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032a2074"]])

export default __exports__